import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SurveyApiService } from '../survey-main/survey-api.service';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, Subscription } from 'rxjs';
import { CommentCardCustomizationDTO, Language } from '../shared/Models/WidgetSettingsModels';
import { PropertyTypeId } from '../shared/constants/commonenums';
@Component({
  selector: 'app-survey-main',
  templateUrl: './survey-main.component.html',
  styleUrls: ['./survey-main.component.scss']
})

export class SurveyMainComponent implements OnInit {
  restaurentName: any = "";
  restaurenDetails: any = "";
  token: any = "";
  public questions: any = [];
  restaurantId: Number;
  public commentcardStyles: BehaviorSubject<CommentCardCustomizationDTO>;
  public getsurveyelement: any;
  public getsurveyproperty: any;
  public isdatavalid: boolean = false;
  public isvalid: boolean = false;
  public question: any;
  subscriptions: Subscription = new Subscription();
  public languageId: number = 1;
  public contactId: number;
  constructor(private httpSurveyApi: SurveyApiService, private route: ActivatedRoute, private toastr: ToastrService) {

  }
  ngOnInit(): void {

    this.restaurentName = this.route.snapshot.paramMap.get('restaurantName')
    this.token = this.route.snapshot.paramMap.get('partyToken')
    this.languageId = Language[this.route.snapshot.paramMap.get('languageId')]
    this.contactId = this.route.snapshot.params.contactId
    this.subscriptions.add(this.httpSurveyApi.dataSaved$.subscribe(data=>{
    this.isvalid =false;
    }));
    this.getSurveyQuestions();
  }

  getCommentcardCustomizations() {
    this.httpSurveyApi.getCommentCardCustomization(this.restaurantId).subscribe((response: any) => {
      this.commentcardStyles = response.Payload;
      console.log(this.commentcardStyles)
    }, error => {
      console.log(error);
    })
  }

  getAllQuestions(surveyDetails) {
    //this.httpSurveyApi.getQuestions(Id).subscribe((response: any) => {

    this.questions = [];
    this.questions = surveyDetails.FeedbackQuestionaries;
    this.questions.forEach((element: any) => {
      element['type'] = 'rating';
      element['options'] = [
        { rating: 1, label: 'Bad' },
        { rating: 2, label: 'Ok' },
        { rating: 3, label: 'Good' },
        { rating: 4, label: 'Very Good' },
        { rating: 5, label: 'Excellent' }
      ];


      element['rating'] = 0;

    });

    this.questions.push({ rating: 0, type: 'text', value: '', FeedbackQuestion: 'Any Suggestion' });
    this.httpSurveyApi.setQuestion(this.questions);
    console.log(this.questions);
    // }, error => {
    //   console.log(error);
    // })
  }

  public getTokens(): any {
    this.httpSurveyApi.getTokens(this.token).subscribe((response: any) => {
      console.log(response);
      if (response && response.State == 0) {
        this.getsurveyelement = response;
        this.isdatavalid = true;
        this.getsurveyelement['isActivity'] = this.isActivity(this.getsurveyelement?.Payload?.PropertyTypeId);
        this.getsurveyelement['currentGuest'] = this.getsurveyelement?.Payload?.BookingContacts?.find(x => x.ContactId == this.contactId);

        this.getsurveyelement['bookingDate'] = this.getsurveyelement['isActivity'] ? this.getsurveyelement?.Payload?.StartDate : 
                    (this.getsurveyelement?.Payload?.ReservedFor ? this.getsurveyelement?.Payload?.ReservedFor : this.getsurveyelement?.Payload?.ArrivedAt);

        if(this.getsurveyelement.Payload.Feedbacks && this.getsurveyelement.Payload.Feedbacks.length > 0 &&
          this.getsurveyelement.Payload.Feedbacks.find(x => x.ContactId == this.contactId))
        {
          this.isvalid =false;
        }else{
          this.isvalid =true;
        }


        if (this.getsurveyelement.Payload.RestaurantId != this.getsurveyproperty.Id) {
          this.toastr.error('ERROR !', 'Invalid Data !!!', {
            timeOut: 10000,
          });
          this.isdatavalid = false;
          // this.isvalid=false;
        }
      }
    }, error => {
      console.log(error);
      this.isdatavalid = false;
      this.toastr.error('ERROR !', error, {
        timeOut: 10000,
      });
    })
  }

  public getImage(Id: any): any {
    console.log(this.getImage);
    this.httpSurveyApi.getImage(Id).subscribe((response: any) => {
      console.log(response);
      //  this.getsurveyelement = response;

      this.httpSurveyApi.setImage(response);
      // this.getTokens(response.Payload.Token);


    })
  }

  isActivity(propertyType): boolean {
    if (propertyType && (propertyType == PropertyTypeId.TennisCenter || propertyType == PropertyTypeId.General)) {
      return true;
    } else {
      return false;
    }
  }

  public getSurveyQuestions(): any {
    this.httpSurveyApi.getFeedbackSurveyQuestions(this.restaurentName, this.languageId).subscribe((response: any) => {
      var output = response;
      if (output && output.State == 0 && output.Payload && output.Payload.FeedbackQuestionaries && output.Payload.Property) {
        this.getsurveyproperty = response.Payload.Property;
        this.restaurantId = response.Payload.Property.Id;
        this.getAllQuestions(response.Payload);
        this.getCommentcardCustomizations();
        if (this.token != 'xx-commentCard-Prievew-xx') {
          this.getTokens()
        }
        else {
          this.getsurveyelement = { "Payload": { "ReservedFor": new Date(), "Contact": { "FirstName": "<First Name> ", "LastName": "<Last Name>", "VisitStats": [{ "RestaurantId": this.restaurantId, "RestaurantName": response.Payload.Property.Name }] } } }
          this.isdatavalid = true;
          this.isvalid = true;
        }
        ///this.getAllQuestions(response.Payload.RestaurantId)
        this.getImage(this.restaurantId)
      } else {
        this.toastr.error('ERROR !', 'Invalid Data !!!', {
          timeOut: 10000,
        });
        this.isdatavalid = false;
      }

    }, error => {
      console.log(error);
      this.toastr.error('ERROR !', 'Invalid Data !!!', {
        timeOut: 10000,
      });
      this.isdatavalid = false;
    })
  }



}


